/**
 * DealsRolesContext — RW-1543: one place for the One Pipeline role gates so
 * the desktop rail (DealsShell), the mobile pill strip (DealsNav), and the
 * surfaces all agree. UI show/hide only — every mutation re-checks on the
 * callable (dealsApi / complianceApi are the real filters).
 *
 * Server mirrors (keep in lockstep):
 *   canManage — dealsApi MANAGE_ROLES: admin | tc | agent_services
 *   canReview — complianceApi REVIEW_ROLES: admin | broker | tc
 *               (deliberately EXCLUDES agent_services — they'd pass the old
 *               canManage gate and then fail every server call)
 *   canLead   — dealsApi canApproveGate: admin | broker
 *   canFillForms — docusignFunctions requireDealMember's staff arm (RW-2824):
 *               admin | tc | agent_services | broker fill forms on ANY deal.
 *               Everyone else fills only on a deal they're on (DealDetail
 *               checks primary agent / TC).
 *
 * isAdmin (RW-2298) is the feature-flag bypass, not a deals role: DealsNav
 * gates each pill with isFeatureEnabled(flagKey, flags, isAdmin) exactly as
 * Sidebar gates the row, and admins see every flag as ON.
 *
 * windingDown (RW-3878) is App.js's isWindingDown (RW-899 stage 1): DealsNav
 * drops a pill the wind-down allowlist refuses (the two Market boards), the
 * same filter Sidebar and MobileNav apply to the rail.
 */
import { createContext, useContext } from 'react';

const DealsRolesContext = createContext({
  canManage: false,
  canReview: false,
  canLead: false,
  canFillForms: false,
  canViewDeals: false,
  isAdmin: false,
  windingDown: false,
});

export const DealsRolesProvider = DealsRolesContext.Provider;
export function useDealsRoles() { return useContext(DealsRolesContext); }
